import {
  ChangeDetectorRef,
  Component,
  HostListener,
  ElementRef,
  Inject,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { FormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { DOCUMENT } from '@angular/common';

import { applyMixins } from 'utils/utils';
import { BaseSegmentComponent } from '../base/_base-segment.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';
import { IconsDropdownComponent } from 'shared/dropdown/icons-dropdown/icons-dropdown.component';
import { PricingMixin } from '../../../product-details/components/pricing/pricing-mixin';
import { pricingConfig } from '../../../product-details/components/pricing/pricing-config';
import { ProductPanelService } from '../../product-panel.service';
import { segmentsData } from '../../../product-details/segments-data-stub';

import { BrandService } from 'shared/brand/brand.service';
import { ItemDetailService } from 'shared/item-detail/item-detail.service';
import { PriceSheetService } from 'shared/price-sheet/price-sheet.service';
import { SearchService } from 'shared/search/search.service';
import { ECOMMERCE_PANEL } from '../../../product-panel/product-panel-types';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';


@Component({
  moduleId: module.id,
  selector: 'pricing-segment',
  templateUrl: 'pricing.component.html',
  styleUrls: ['pricing.component.scss'],
})
class PricingComponent extends BaseSegmentComponent implements OnInit, OnDestroy, PricingMixin {

  pricingFormGroup: UntypedFormGroup;

  currencyCode: string = pricingConfig.currencyCode;
  declare data: Array<any>;
  currency: any;
  itemDetailsPrices: any = [];
  declare itemDetailsData: any;
  isComponentActive: boolean = true;
  priceSheets: Array<any> = [];
  pricingContainerWidth: number;
  showMore: boolean = false;
  showMoreData: Array<any>;
  segmentName: string = 'prices';
  panelTypeFields: any = {
    [ECOMMERCE_PANEL]: [
      'RET', 'JBR', 'RMP', 'UNL'
    ],
  };

  selectedPriceSheet1: any = {};
  selectedPriceSheet2: any = {};
  priceSheetsItems1: Array<any> = [];
  priceSheetsItems2: Array<any> = [];
  sortDirection: string = 'asc';
  addDropdownPriceSheets: (apriceSheets: any) => void;
  addCurrencyDropdownData: () => void;
  onPriceSheetChange: (priceSheet: any, number: number) => void;
  onPriceTypeSortClick: () => void;

  @ViewChild('pricingScroll', {static: false}) pricingScroll: ElementRef | void;

  @ViewChild(HiddenScrollComponent, {static: false}) hiddenScroll: HiddenScrollComponent | void;

  @ViewChild('priceSheetsDropdown1', {static: false})
  priceSheetsDropdown1: IconsDropdownComponent | void;

  @ViewChild('priceSheetsDropdown2', {static: false})
  priceSheetsDropdown2: IconsDropdownComponent | void;

  constructor(
    protected productPanelService: ProductPanelService,
    protected brandService: BrandService,
    protected itemDetailService: ItemDetailService,
    protected searchService: SearchService,
    protected route: ActivatedRoute,
    protected changeDetectorRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private priceSheetService: PriceSheetService,
    @Inject(DOCUMENT) private document: any,
  ) {
    super(productPanelService, brandService, itemDetailService, searchService, route, changeDetectorRef);
  }

  get segmentForm(): UntypedFormGroup {
    return this.pricingFormGroup;
  }

  get priceSheetTitle1(): string {
    return this.selectedPriceSheet1.title || this.selectedPriceSheet1.price_sheet_name || this.selectedPriceSheet1.price_sheet_number;
  }

  get priceSheetTitle2(): string {
    return this.selectedPriceSheet2.title || this.selectedPriceSheet2.price_sheet_name || this.selectedPriceSheet2.price_sheet_number;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.hiddenScroll instanceof HiddenScrollComponent) {
      this.hiddenScroll.defineContentWidth();
    }
  }

  onActiveElementBlur() {
    if (document.activeElement) {
      (<any>document.activeElement).blur();
    }
  }

  onPaste(event: any, selectedPriceSheet: any, item: any) {
    event.preventDefault();
    // get pasted data
    const clipboardData: any = event.clipboardData || (<any>window).clipboardData;
    if (!clipboardData) { return; }
    const pastedData: any = clipboardData.getData('Text');
    // split by newline
    const valuesArray = pastedData.split('\n');
    let index = _.findIndex(this.data, item);
    // get segments sequence
    let segments: any;
    if (index === -1) {
      index = _.findIndex(this.showMoreData, item);
      segments = _.slice(this.showMoreData, index);
    } else {
      segments = _.concat(_.slice(this.data, index), this.showMoreData);
    }
    // set every price to the control
    _.each(valuesArray, (price: any, i: number) => {
      price = price.replace(',', '.');
      if (!price || isNaN(price)) { return; }
      const _item = segments[i];
      if (!_item) { return; }
      const control = this.getPriceControl(
        selectedPriceSheet.price_sheet_number,
        this.currencyCode,
        _item.item_name
      );
      const decimal = price.split('.')[1];
      if (decimal && decimal.length > 4) {
        price = price.slice(0, 7);
      }
      control.setValue(price);
      control.markAsDirty();
    });
  }

  ngOnInit() {
    if (this.panelType === ECOMMERCE_PANEL) { this.showMore = true; }
    this.pricingFormGroup = this.fb.group({});
    this.pickOutShowMoreData(this.getPanelSegmentsData(segmentsData.prices));
    this.addCurrencyDropdownData();
    this.subscribeToItemDetail();
  }

  ngOnDestroy() {
    this.isComponentActive = false;
    super.ngOnDestroy();
  }

  onCurrencyChange(event: any) {
    this.currencyCode = event.code;
  }

  onAddPriceTypeClick(item: any) {
    this.showMoreData.push({
      'item_name': '',
      'title': '',
      'example': '',
      'sequence': this.showMoreData.length,
      'show_more': false,
      'lookup': false
    });
  }

  getPrice(item: any, priceSheet: any): string | null {
    const currency = this.getItemProperty(
      item, `${priceSheet.price_sheet_number}.${item.item_name}.${this.currencyCode}`,
      this.itemDetailsPrices
    );
    if (!currency) { return null; }
    return currency.price ? currency.price : null;
  }

  // replace parent method:
  subscribeToItemDetail() {
    if (this.bulkEdit) {
      this.setBulkData();
    } else {
      forkJoin([
        this.itemDetailService.fetchItemDetail(this.brandId, this.itemId),
        this.priceSheetService.fetchAll(this.brandId)
      ]).subscribe(results => {
        this.handleItemDetail(results);
        this.setSegmentsValidation(results[0]);
      });
    }
  }

  // replace parent method:
  setBulkData() {
    this.priceSheetService.fetchAll(this.brandId)
    .subscribe(prices => {
      this.itemDetailsData = [
        {'prices': this.getBulkSegmentData(this.segmentName)}, prices
      ];
      this.setData(this.itemDetailsData);
    });
  }

  // replace parent method:
  handleItemDetail(itemDetail: any) {
    this.itemDetailsData = itemDetail;
    this.setData(itemDetail);
  }

  buildPriceSheetFormGroup(priceSheet: any, prices: any) {
    const formGroup: UntypedFormGroup = new UntypedFormGroup({});

    _.each(segmentsData.prices, (data: any) => {

      const currencyFormGroup: UntypedFormGroup = new UntypedFormGroup({});
      _.each(this.currency, (currency: any) => {
        const price: string = _.get(prices,
          `${priceSheet.price_sheet_number}.${data.item_name}.${currency.code}${this.bulkEdit ? '' : '.price'}`, '');
        currencyFormGroup.addControl(currency.code, new UntypedFormControl(price, []));
      });
      formGroup.addControl(data.item_name, currencyFormGroup);
    });
    if (this.pricingFormGroup.get(priceSheet.price_sheet_number)) { this.pricingFormGroup.removeControl(priceSheet.price_sheet_number); }
    this.pricingFormGroup.addControl(priceSheet.price_sheet_number, formGroup);

  }

  getPriceControl(priceSheetNumber: string, currency: string, priceType: string): UntypedFormControl {
    const priceSheetGroup: UntypedFormGroup = <UntypedFormGroup>this.pricingFormGroup.controls[priceSheetNumber];
    const priceTypeGroup: UntypedFormGroup = <UntypedFormGroup>priceSheetGroup.controls[priceType];
    const currencyControl: UntypedFormControl = <UntypedFormControl>priceTypeGroup.controls[currency];
    return currencyControl;
  }

  save(): Observable<any> {
    if (this.bulkEdit) {
      return this.putDataBulk(this.segmentName, this.pricingFormGroup.value);
    } else {
      const { id } = this.route.snapshot.params;
      return this.putData(id, this.segmentName, this.pricingFormGroup.value);
    }
  }

  setData(results: any) {
    if (results[0].prices) {
      this.itemDetailsPrices = results[0].prices;
    }
    this.changeDetectorRef.markForCheck();
    this.addDropdownPriceSheets(results[1]);
    this.priceSheets = results[1];
    _.each(this.priceSheets, (priceSheet) => {
        this.buildPriceSheetFormGroup(priceSheet, this.itemDetailsPrices);
    });
  }
}

applyMixins(PricingComponent, [PricingMixin]);

export { PricingComponent };
